import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import toast, { type Toast } from 'react-hot-toast';

interface ToastContentProps {
  toastInstance: Toast;
  message: string;
}

export function ToastContent({ toastInstance, message }: ToastContentProps) {
  const { t } = useTranslation('common');
  return (
    <div className="flex min-w-0 items-start gap-2">
      <p className="min-w-0 flex-1 leading-snug">{message}</p>
      <button
        type="button"
        onClick={() => toast.dismiss(toastInstance.id)}
        className="-mr-1 -mt-0.5 shrink-0 rounded-md p-0.5 text-current opacity-60 transition-opacity hover:opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-current/30"
        aria-label={t('labels.dismissNotification')}
      >
        <CloseIcon sx={{ fontSize: 18 }} />
      </button>
    </div>
  );
}

export function renderToastContent(message: string) {
  return (toastInstance: Toast) => (
    <ToastContent toastInstance={toastInstance} message={message} />
  );
}
